import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const totalPriceFooter: ThemeApp['appComponents']['totalPriceFooter'] = {
  borderTop: `1px solid ${themeUi.semantic.color.border.secondary800}`
};
